import React, { FC, useContext, useState } from 'react'
import { observer } from 'mobx-react'
import { Header } from '../../components/Header/Header'
import {
  ContentWrap,
  Footer,
  FormWrap,
  InputWrap,
  Page,
} from './FormPage.styles'
import { StoreContext } from '../../components/App'
import encodeUrl from 'encodeurl'

const proxy_url = 'https://sample-bank-conditions-proxy.vercel.app/'
export const FormPage: FC = observer(() => {
  const store = useContext(StoreContext)
  const { firstName, lastName, dateOfBirth, email, phoneNumber, emailValid } =
    store.AppState

  const [isLoading, setIsLoading] = useState(false)

  const proceed = () => {
    setIsLoading(true)

    const params = `firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}&email=${email}&phoneNumber=${phoneNumber}`
    window.location.href = encodeUrl(`${proxy_url}?${params}`)
  }

  return (
    <Page>
      <Header />
      <ContentWrap>
        <h1>Open an account</h1>

        <h2>
          Please provide the following information so we can quickly and easy
          onboard you
        </h2>
        <FormWrap>
          <InputWrap>
            <label>First name</label>
            <input
              autoComplete="given-name"
              type="text"
              value={firstName}
              onChange={(e) => store.AppState.setFirstName(e.target.value)}
            />
          </InputWrap>
          <InputWrap>
            <label>Last name</label>
            <input
              autoComplete="family-name"
              type="text"
              value={lastName}
              onChange={(e) => store.AppState.setLastName(e.target.value)}
            />
          </InputWrap>
          <InputWrap>
            <label>Date of birth</label>
            <input
              autoComplete="bday"
              type="date"
              value={dateOfBirth}
              onChange={(e) => store.AppState.setDateOfBirth(e.target.value)}
            />{' '}
          </InputWrap>
          <InputWrap>
            <label>Email</label>
            <input
              autoComplete="email"
              type="text"
              value={email}
              onChange={(e) => store.AppState.setEmail(e.target.value)}
            />
          </InputWrap>
          <InputWrap>
            <label>Phone number</label>
            <input
              autoComplete="tel"
              type="tel"
              value={phoneNumber}
              onChange={(e) => store.AppState.setPhoneNumber(e.target.value)}
            />{' '}
          </InputWrap>
        </FormWrap>

        <Footer>
          <button
            onClick={proceed}
            disabled={
              isLoading ||
              !firstName ||
              !lastName ||
              !dateOfBirth ||
              !email ||
              !phoneNumber ||
              !emailValid
            }
          >
            Open an account
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12.9597 6.54048C12.7059 6.28664 12.2943 6.28664 12.0405 6.54048C11.7866 6.79432 11.7866 7.20588 12.0405 7.45972L15.9308 11.3501L6.5001 11.3501C6.14111 11.3501 5.8501 11.6411 5.8501 12.0001C5.8501 12.3591 6.14111 12.6501 6.5001 12.6501L15.9309 12.6501L12.0405 16.5405C11.7866 16.7943 11.7866 17.2059 12.0405 17.4597C12.2943 17.7136 12.7059 17.7136 12.9597 17.4597L17.9597 12.4597C18.2136 12.2059 18.2136 11.7943 17.9597 11.5405L12.9597 6.54048Z"
                fill="white"
              />
            </svg>
          </button>
        </Footer>
      </ContentWrap>
    </Page>
  )
})
